import React from "react";
import FavoriteButton from "./FavoriteButton";
import { ReportUtilityButtonContainer } from "../styled/ReportUtilities";
import { useVsiAppContext } from "../stores/VsiApp";
import { withErrorBoundary } from "../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "../boundaries/GeneralErrorBoundary";

function ReportUtilityBar (props) {

	const { isTabletScreen } = useVsiAppContext();
	return <ReportUtilityButtonContainer $isTabletScreen={isTabletScreen}>
		<FavoriteButton {...props} />
	</ReportUtilityButtonContainer>
}

export default withErrorBoundary(ReportUtilityBar, GeneralErrorBoundary);
